import { useEffect, useState } from "react";
import styles from "../../../homepage/pages/Calculators.module.css";
import { analytics, logEvent } from "../../../../firebase.js";

import { BlockMath, InlineMath } from "react-katex";

import Select from "../components/Select";
import InputNumber from "../components/InputNumber";
import Number from "../components/Number";
import Output from "../components/Output";

import { steelTension } from "../../utils/services/calculators";
import { Text, useToast } from "@chakra-ui/react";

import steelSections from "../../utils/data/steelSections.json";

function SteelTension({}) {
  const toast = useToast();
  // BENDING
  const [tensionInputs, setTensionInputs] = useState({
    steel: "ASTM A36",
    steel_type: "Laminado I",
    steel_section: "W 150 x 13,0",
    lx: "",
    ly: "",
    dim_1: steelSections["Laminado I"]["sections"]["W 150 x 13,0"]["bf"],
    dim_2: steelSections["Laminado I"]["sections"]["W 150 x 13,0"]["d"],
    dim_3: steelSections["Laminado I"]["sections"]["W 150 x 13,0"]["tw"],
    dim_4: steelSections["Laminado I"]["sections"]["W 150 x 13,0"]["tf"],
    properties: steelSections["Laminado I"]["sections"]["W 150 x 13,0"],
    ct: 1,
    coef_na: 0.8,
    nsd: "",
  });
  const [tensionOutputs, setTensionOutputs] = useState({
    lambd_x: "",
    lambd_y: "",
    nt_rd_1: "",
    nt_rd_2: "",
    nt_rd_3: "",
    memorial: {},
  });

  function onChangeSteelType(value) {
    if (value === "Laminado I") {
      const firstSection = "W 150 x 13,0";
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        steel_section: firstSection,
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_1: steelSections[value]["sections"][firstSection]["bf"],
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_2: steelSections[value]["sections"][firstSection]["d"],
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_3: steelSections[value]["sections"][firstSection]["tw"],
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_4: steelSections[value]["sections"][firstSection]["tf"],
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        properties: steelSections[value]["sections"][firstSection],
      }));
    } else if (
      value === "Chapa Dobrada U" ||
      value === "Chapa Dobrada 2U" ||
      value === "Chapa Dobrada Cant. Dupla" ||
      value === "Tubo Retangular Vazado"
    ) {
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        steel_section: "",
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_1: "",
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_2: "",
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_3: "",
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_4: null,
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        properties: null,
      }));
    } else if (
      value === "Chapa Dobrada Cant. Simples" ||
      value === "Tubo Circular Vazado" ||
      value === "Barra Retangular (Chata)"
    ) {
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        steel_section: "",
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_1: "",
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_2: "",
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_3: null,
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_4: null,
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        properties: null,
      }));
    } else if (value === "Cantoneira Simples") {
      const firstSection = 'L 1/2" x 1/8"';
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        steel_section: firstSection,
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_1: steelSections[value]["sections"][firstSection]["b"],
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_2: steelSections[value]["sections"][firstSection]["t"],
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_3: null,
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_4: null,
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        properties: steelSections[value]["sections"][firstSection],
      }));
    } else if (value === "Cantoneira Dupla") {
      const firstSection = 'L 1/2" x 1/8"';
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        steel_section: firstSection,
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_1: steelSections[value]["sections"][firstSection]["b"],
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_2: steelSections[value]["sections"][firstSection]["t"],
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_3: "",
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_4: null,
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        properties: steelSections[value]["sections"][firstSection],
      }));
    } else if (value === "Barra Circular") {
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        steel_section: "",
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_1: "",
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_2: null,
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_3: null,
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_4: null,
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        properties: null,
      }));
    } else {
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        steel_section: "",
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_1: "",
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_2: "",
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_3: "",
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        dim_4: "",
      }));
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        properties: null,
      }));
    }
  }

  function updateTensionInputs(name, value) {
    if (name === "steel" || name === "steel_section" || name === "properties") {
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else if (name === "steel_type") {
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
      onChangeSteelType(value);
    } else if (value === "") {
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else {
      setTensionInputs((prevInputs) => ({
        ...prevInputs,
        [name]: parseFloat(value),
      }));
    }
    setTensionOutputs({
      lambd_x: "",
      lambd_y: "",
      nt_rd_1: "",
      nt_rd_2: "",
      nt_rd_3: "",
    });
  }

  function onChangeSteelSection(steel_type, value) {
    if (steel_type === "Laminado I") {
      updateTensionInputs("steel_section", value);
      updateTensionInputs(
        "dim_1",
        steelSections[steel_type]["sections"][value]["bf"]
      );
      updateTensionInputs(
        "dim_2",
        steelSections[steel_type]["sections"][value]["d"]
      );
      updateTensionInputs(
        "dim_3",
        steelSections[steel_type]["sections"][value]["tw"]
      );
      updateTensionInputs(
        "dim_4",
        steelSections[steel_type]["sections"][value]["tf"]
      );
      updateTensionInputs(
        "properties",
        steelSections[steel_type]["sections"][value]
      );
    } else if (steel_type === "Cantoneira Simples") {
      updateTensionInputs("steel_section", value);
      updateTensionInputs(
        "dim_1",
        steelSections[steel_type]["sections"][value]["b"]
      );
      updateTensionInputs(
        "dim_2",
        steelSections[steel_type]["sections"][value]["t"]
      );
      updateTensionInputs(
        "properties",
        steelSections[steel_type]["sections"][value]
      );
    } else if (steel_type === "Cantoneira Dupla") {
      updateTensionInputs("steel_section", value);
      updateTensionInputs(
        "dim_1",
        steelSections[steel_type]["sections"][value]["b"]
      );
      updateTensionInputs(
        "dim_2",
        steelSections[steel_type]["sections"][value]["t"]
      );
      updateTensionInputs(
        "properties",
        steelSections[steel_type]["sections"][value]
      );
    }
  }

  function onTensionCalculate() {
    if (
      tensionInputs["lx"] === "" ||
      tensionInputs["ly"] === "" ||
      tensionInputs["dim_1"] === "" ||
      tensionInputs["dim_2"] === "" ||
      tensionInputs["dim_3"] === "" ||
      tensionInputs["dim_4"] === "" ||
      tensionInputs["ct"] === "" ||
      tensionInputs["coef_na"] === "" ||
      tensionInputs["nsd"] === ""
    ) {
      console.log(tensionInputs);
      toast({
        title: "Preencha todos os campos",
        status: "warning",
        isClosable: true,
      });
    } else if (
      tensionInputs["lx"] === 0 ||
      tensionInputs["ly"] === 0 ||
      tensionInputs["dim_1"] === 0 ||
      tensionInputs["dim_2"] === 0 ||
      tensionInputs["dim_3"] === 0 ||
      tensionInputs["dim_4"] === 0 ||
      tensionInputs["ct"] === 0 ||
      tensionInputs["coef_na"] === 0 ||
      tensionInputs["nsd"] === 0
    ) {
      toast({
        title: "Os valores devem ser diferentes de 0",
        status: "warning",
        isClosable: true,
      });
    } else {
      steelTension(tensionInputs).then((response) => {
        setTensionOutputs(response["data"]);
        logEvent(analytics, "button_click", {
          button_name: "steel-tension-calculator-button",
        });
      });
    }
  }

  useEffect(() => {
    logEvent(analytics, "page_view", { page: "steel-tension-calculator" });
  }, []);

  return (
    <div className={styles.section} key={"header"}>
      <h1 className={styles.calculatorName}>Tração:</h1>
      <div className={styles.calculator}>
        <div className={styles.inputs}>
          <div className={styles.inputRow}>
            <h3 className={styles.rowTitle}>Dados de entrada:</h3>
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Lx"
              unit="cm"
              onChange={(e) => updateTensionInputs("lx", e.target.value)}
            />
            <InputNumber
              text="Ly"
              unit="cm"
              onChange={(e) => updateTensionInputs("ly", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Tipo"
              elements={Object.keys(steelSections)}
              unit=""
              onChange={(e) =>
                updateTensionInputs("steel_type", e.target.value)
              }
              value={tensionInputs["steel_type"]}
            />
            <Select
              text="Aço"
              elements={["ASTM A36", "ASTM A572 Grau 50"]}
              unit=""
              onChange={(e) => updateTensionInputs("steel", e.target.value)}
              value={tensionInputs["steel"]}
            />
          </div>
          {steelSections[tensionInputs["steel_type"]]["preSet"] === true && (
            <div className={styles.inputRow}>
              <Select
                text="Seção"
                elements={Object.keys(
                  steelSections[tensionInputs["steel_type"]]["sections"]
                )}
                unit=""
                onChange={(e) => {
                  onChangeSteelSection(
                    tensionInputs["steel_type"],
                    e.target.value
                  );
                }}
                value={tensionInputs["steel_section"]}
              />
            </div>
          )}
          <>
            {/* Não adianta agrupar os types que possuem os mesmos primeiros dois inputs pq dai quando troca steel_type n atualiza */}
            {tensionInputs["steel_type"] === "Laminado I" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="b"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_1", e.target.value)}
                  firstValue={tensionInputs["dim_1"]}
                  isDisabled={true}
                />
                <InputNumber
                  text="h"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_2", e.target.value)}
                  firstValue={tensionInputs["dim_2"]}
                  isDisabled={true}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Soldado I" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="b"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_1", e.target.value)}
                />
                <InputNumber
                  text="h"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_2", e.target.value)}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Chapa Dobrada U" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="b"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_1", e.target.value)}
                />
                <InputNumber
                  text="h"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_2", e.target.value)}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Chapa Dobrada 2U" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="b"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_1", e.target.value)}
                />
                <InputNumber
                  text="h"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_2", e.target.value)}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Chapa Dobrada Ue" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="b"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_1", e.target.value)}
                />
                <InputNumber
                  text="h"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_2", e.target.value)}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Chapa Dobrada 2Ue" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="b"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_1", e.target.value)}
                />
                <InputNumber
                  text="h"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_2", e.target.value)}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Chapa Dobrada Cant. Simples" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="b"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_1", e.target.value)}
                />
                <InputNumber
                  text="t"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_2", e.target.value)}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Chapa Dobrada Cant. Dupla" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="b"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_1", e.target.value)}
                />
                <InputNumber
                  text="t"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_2", e.target.value)}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Cantoneira Simples" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="b"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_1", e.target.value)}
                  firstValue={tensionInputs["dim_1"]}
                  isDisabled={true}
                />
                <InputNumber
                  text="t"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_2", e.target.value)}
                  firstValue={tensionInputs["dim_2"]}
                  isDisabled={true}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Cantoneira Dupla" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="b"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_1", e.target.value)}
                  firstValue={tensionInputs["dim_1"]}
                  isDisabled={true}
                />
                <InputNumber
                  text="t"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_2", e.target.value)}
                  firstValue={tensionInputs["dim_2"]}
                  isDisabled={true}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Tubo Circular Vazado" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="Ø"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_1", e.target.value)}
                />
                <InputNumber
                  text="t"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_2", e.target.value)}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Tubo Retangular Vazado" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="b"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_1", e.target.value)}
                />
                <InputNumber
                  text="h"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_2", e.target.value)}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Barra Circular" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="Ø"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_1", e.target.value)}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Barra Retangular (Chata)" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="b"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_1", e.target.value)}
                />
                <InputNumber
                  text="h"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_2", e.target.value)}
                />
              </div>
            )}
          </>
          <>
            {tensionInputs["steel_type"] === "Laminado I" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="tw"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_3", e.target.value)}
                  firstValue={tensionInputs["dim_3"]}
                  isDisabled={true}
                />
                <InputNumber
                  text="tf"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_4", e.target.value)}
                  firstValue={tensionInputs["dim_4"]}
                  isDisabled={true}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Soldado I" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="tw"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_3", e.target.value)}
                />
                <InputNumber
                  text="tf"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_4", e.target.value)}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Chapa Dobrada U" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="t"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_3", e.target.value)}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Chapa Dobrada 2U" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="t"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_3", e.target.value)}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Chapa Dobrada Ue" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="d"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_3", e.target.value)}
                />
                <InputNumber
                  text="t"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_4", e.target.value)}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Chapa Dobrada 2Ue" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="d"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_3", e.target.value)}
                />
                <InputNumber
                  text="t"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_4", e.target.value)}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Chapa Dobrada Cant. Dupla" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="e"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_3", e.target.value)}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Cantoneira Dupla" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="e"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_3", e.target.value)}
                />
              </div>
            )}
            {tensionInputs["steel_type"] === "Tubo Retangular Vazado" && (
              <div className={styles.inputRow}>
                <InputNumber
                  text="t"
                  unit="mm"
                  onChange={(e) => updateTensionInputs("dim_3", e.target.value)}
                />
              </div>
            )}
          </>
          <div className={styles.inputRow}>
            <InputNumber
              text="Ct"
              unit=""
              onChange={(e) => updateTensionInputs("ct", e.target.value)}
              firstValue={tensionInputs["ct"]}
            />
            <InputNumber
              text="Coef. p/ Na"
              unit=""
              onChange={(e) => updateTensionInputs("coef_na", e.target.value)}
              firstValue={tensionInputs["coef_na"]}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Nsd"
              unit="tf"
              onChange={(e) => updateTensionInputs("nsd", e.target.value)}
            />
          </div>
        </div>
        <div className={styles.buttons}>
          <button
            className={styles.calculateButton}
            onClick={onTensionCalculate}
          >
            CALCULAR
          </button>
        </div>
        <div className={styles.outputs}>
          <div className={styles.outputRow}>
            <h3 className={styles.rowTitle}>Resumo de resultados:</h3>
          </div>
          {tensionOutputs["lambd_x"] === "" ? (
            <h4 className={styles.rowDescription}>λx =</h4>
          ) : (
            <h4 className={styles.rowDescription}>
              {"λx = " + tensionOutputs["lambd_x"].toFixed(2) + " ≤ 300 → "}
              {tensionOutputs["lambd_x"] <= 200 ? "OK!" : "NÃO OK!"}
            </h4>
          )}
          {tensionOutputs["lambd_y"] === "" ? (
            <h4 className={styles.rowDescription}>λy =</h4>
          ) : (
            <h4 className={styles.rowDescription}>
              {"λy = " + tensionOutputs["lambd_y"].toFixed(2) + " ≤ 300 → "}
              {tensionOutputs["lambd_y"] <= 200 ? "OK!" : "NÃO OK!"}
            </h4>
          )}
          <Output text="Nt,Rd 1" value={tensionOutputs["nt_rd_1"]} unit="tf" />
          <Output text="Nt,Rd 2" value={tensionOutputs["nt_rd_2"]} unit="tf" />
          {tensionOutputs["nt_rd_3"] !== "" &&
            tensionOutputs["nt_rd_3"] !== 0 && (
              <Output
                text="Nt,Rd 3"
                value={tensionOutputs["nt_rd_3"]}
                unit="tf"
              />
            )}
          {tensionOutputs["nt_rd_1"] !== "" &&
            (tensionOutputs["nt_rd_3"] !== 0 ? (
              <h4 className={styles.rowDescription}>
                {tensionInputs["nsd"].toFixed(2) +
                  " ≤ " +
                  Math.min(
                    tensionOutputs["nt_rd_1"],
                    tensionOutputs["nt_rd_2"],
                    tensionOutputs["nt_rd_3"]
                  ).toFixed(2) +
                  " → "}
                {tensionInputs["nsd"] <=
                Math.min(
                  tensionOutputs["nt_rd_1"],
                  tensionOutputs["nt_rd_2"],
                  tensionOutputs["nt_rd_3"]
                ).toFixed(2)
                  ? "OK!"
                  : "NÃO OK!"}
              </h4>
            ) : (
              <h4 className={styles.rowDescription}>
                {tensionInputs["nsd"].toFixed(2) +
                  " ≤ " +
                  Math.min(
                    tensionOutputs["nt_rd_1"],
                    tensionOutputs["nt_rd_2"]
                  ).toFixed(2) +
                  " → "}
                {tensionInputs["nsd"] <=
                Math.min(
                  tensionOutputs["nt_rd_1"],
                  tensionOutputs["nt_rd_2"]
                ).toFixed(2)
                  ? "OK!"
                  : "NÃO OK!"}
              </h4>
            ))}
        </div>
      </div>
      <div className={styles.memorial} key={"memorial"}>
        <h1>Memorial de Cálculo:</h1>
        {tensionOutputs["memorial"] &&
          Object.entries(tensionOutputs["memorial"]).map(
            ([className, subclasses]) => (
              <>
                <h2>{className}</h2>
                {Object.entries(subclasses).map(([subclassName, steps]) => (
                  <>
                    <h3>{subclassName}</h3>
                    {steps.map((step) => (
                      <>
                        <h4>{step["description"]}</h4>
                        <div className={styles.mathContainer}>
                          <BlockMath
                            math={step["formula"] + step["calculation"]}
                          />
                        </div>
                      </>
                    ))}
                  </>
                ))}
              </>
            )
          )}
      </div>
    </div>
  );
}

export default SteelTension;
